import { combineReducers } from "redux";
import { HomepageReducer } from "./HomepageReducer";
export default combineReducers({
  HomepageReducer: HomepageReducer,
});
